import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {BaseScaffoldComponent} from '@scaffold/view/rendered/components/base-scaffold/base-scaffold.component';
import {RenderedService} from '@scaffold/view/rendered/rendered.service';
import { NbSortDirection, NbSortRequest, NbTreeGridDataSource, NbTreeGridDataSourceBuilder } from '@nebular/theme';
import { Task, TasksService } from '@services/tasks.service';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';



@Component({
  selector: 'app-up-next',
  templateUrl: './up-next.component.html',
  styleUrls: ['./up-next.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpNextComponent extends BaseScaffoldComponent implements OnInit {
  date = new Date();

  allColumns = [ 'name', 'desc', 'item' ];
  data: Task[] = [
 
  ];

  constructor(public cdr: ChangeDetectorRef, public renderedService: RenderedService, private taskService: TasksService, private router: Router) { super(cdr, renderedService); }

  ngOnInit() {
    this.taskService.getTaskList().subscribe(tasks => {
      if(!tasks)return
      this.data = tasks.map(result => {
        return { description: result.data.description, title: result.target.title, target: result.target }
      })
      console.log(this.data);
      this.update();
    });
  }

  navigate(e: Event, item: Task) {
    e.preventDefault();
    let target = [];
    if (item.target.parent_id) {
      target.push(item.target.parent_type);
      target.push(item.target.parent_id);
    }
    target.push(item.target.type);
    target.push(item.target.id);
    this.router.navigate(target)

  }
}
